const errorMessageHandler = (exception) => {
  if (exception.response?.data?.message) {
    return exception.response.data.message;
  }

  switch (exception.message) {
    case 'Network Error':
      return 'Verifique sua conexão com a internet';
    default:
      return 'Ocorreu um erro inesperado';
  }
};

const errorFieldsHandler = (exception) => {
  const errorFields = {};

  if (exception?.response?.data?.fieldDetails) {
    exception?.response?.data?.fieldDetails.forEach((el) => {
      const actualMessage = errorFields[`${el.object}.${el.field}`];
      errorFields[`${el.object}_${el.field}`] = actualMessage ? ` / ${actualMessage}` : el.message;
    });
  }

  return errorFields;
};

export {
  errorMessageHandler,
  errorFieldsHandler,
};
